module.exports = __webpack_public_path__ + "img/logo-nuvemshop.b91a6d8b.svg";